import * as React from 'react'
import cx from 'classnames'
import styles from './PresenceIndicator.sass'

interface Props {
  present?: boolean
}

export default function PresenceIndicator({ present }: Props) {
  return (
    <div
      className={cx(styles.root, present && styles.present)}
      data-test={`presence-indicator-${present}`}
    />
  )
}
